<template>
	<div :class="darkMode ? 'dark' : ''">

       <!-- Messaggio che appare se si accede da mobile e schermi md -->
		<div id="onlydesktop" class="block md:!hidden"> 
			<div v-if="loggedAs && loggedAs.ruolo=='admin'" id="onlydesktopAdmin" class=" bg-csenRed-200 p-12">
				<div class="bg-csenRed-100 text-csenRed-600 p-3 inline-flex rounded-full mb-4">
					<MobileIcon></MobileIcon>
				</div>
				<div class="bg-csenGreen-100 text-csenGreen-600 p-3 inline-flex rounded-full mb-4">
					<DesktopIcon></DesktopIcon>
				</div>
				<div><h2 class="text-left text-lg text-csenRed-800 font-bold mb-2">⛔ Accesso non consentito</h2></div>
				<p class=" text-left text-csenRed-900 text-base font-semibold">L'accesso come amministratore <strong>non è consentito da mobile</strong>. Collegati da un computer desktop per svolgere le attività come amministratore.</p> 

			</div>
		</div>
      
      <div id="maincontainer" class="hidden md:!block  sm:px-[5%] !font-sans bg-white dark:bg-[#171a35]">
          <div class="bg-csenBlue-950 dark:bg-csenBlue-900 rounded-b-md px-12 sm:px-24 py-12">
             <!-- MENU TECNICI -->
             <MenuTecnici @avvia-guida="avviaTour"></MenuTecnici>
             <!-- INIZIO RICERCA -->
             <div flat class="mt-6 bg-white px-6 py-3 rounded-md">
                <v-text-field
                   v-model="search"
                   hide-details
                   flat 
                   solo
                   light
                   class="relative w-full border-none rounded-lg "
                   prepend-icon="mdi-magnify"
                   clearable
                   placeholder="Cerca modello e-mail"
                   clear-icon="mdi-close-circle-outline"
                   @click:clear="resetSearch()"
                   ></v-text-field>
             </div>
             <!-- FINE RICERCA -->
          </div>
          <div class="flex justify-end mt-3 mb-0 py-2 rounded-md gap-x-2">
             <v-btn id="aggiungi-modello-email" @click="openModelloEmailDialog()" class="!bg-csenBlue-900 !text-white dark:!bg-csenBlue-700 !tracking-normal !py-6">
                <PlusIcon class="text-csenBlue-300 mr-2"></PlusIcon>
                <span>Crea un nuovo modello email</span>
             </v-btn>
          </div>
            <div id="tabella" class="py-3">
               <v-data-table id="tabella-modelli-email" class="tabella-csen" :headers="headers" :items="modelli_email" :loading="isLoading" :search="search">
                  <template v-slot:item.created_at="{ item }">
                     <span>{{ formattaDatatime(item.created_at, separatoreDataOra = 'T', convertiDaUTC = true)}}</span>   
                  </template>
                  <template v-slot:item.azioni="{ item }">
                     <div class="d-flex justify-end gap-1">
                        <v-btn
                           id="duplica-modello-email"
                           class="!bg-sky-100 !text-sky-600 dark:!text-white dark:!bg-sky-600 !tracking-normal !px-4"
                           @click="duplicaModelloEmail(item.id)"
                           title="Crea una copia del Modello"
                        >
                           <v-icon left>mdi-content-copy</v-icon>
                           <span>Duplica</span>
                        </v-btn>
                        <button
                           id="modifica-modello-email"
                           type="button"
                           @click="openModelloEmailDialog(item.id)"
                           class="bg-csenOrange-100 !text-csenOrange-500 dark:bg-csenOrange-500 dark:!text-white inline-flex justify-center content-center px-auto rounded-md hover:bg-csenOrange-500 hover:!text-white dark:hover:!brightness-125 transition w-9 h-9" 
                           title="Modifica Modello"
                        >
                           <EditIcon class="my-auto"></EditIcon>
                      </button>
                      <button
                           id="elimina-modello-email"
                           type="button"
                           class=" bg-red-100 dark:bg-csenRed-500 !text-csenRed-500 dark:!text-white  inline-flex justify-center content-center px-auto rounded-md hover:bg-csenRed-500 hover:!text-white dark:hover:!brightness-125 transition w-9 h-9" 
                           title="Elimina Modello"
                           @click="eliminaModelloEmail(item.id)"
                        >
                           <DeleteIcon class="my-auto"></DeleteIcon>
                      </button>
                   </div>
                </template>
             </v-data-table>
          </div>
          <!-- DIALOG Modello email -->
          <template>
             <v-dialog v-model="modelloEmailDialog" width="1200px" persistent>
               <!-- @click:outside="closeModelloEmailDialog()" -->
               <v-card plain class="dark:!bg-csenBlue-900 ">
                   <v-card-title class="font-bold text-2xl py-6 pl-8 dark:!bg-csenBlue-800 border-b border-b-gray-200 dark:border-none">
                      <span class="flex-grow">
                         <h2>
                           Aggiungi / Modifica modello e-mail
                         </h2>
                      </span>
                      <v-btn class="!text-gray-900 dark:!text-csenBlue-200" icon @click="closeModelloEmailDialog()">
                         <CloseIcon />
                      </v-btn>
                   </v-card-title>
                   <v-card-text class="!m-0 !p-0">
                     <div class="my-5 mx-8">
                        <!-- <div class="p-4 flex justify-end">
                           
                        </div> -->
                        <ModelloEmailComponent ref="modelloEmailRef" :id="idModelloEmailAperto" @modello-email-modifica-sospesa="modelloEmailModificato = true" @modello-email-aggiunto-modificato="modelloEmailAggiuntoModificato"></ModelloEmailComponent>
                     </div>
                   </v-card-text>
                   <v-divider></v-divider>
                   <v-card-actions class="p-4 justify-between !bg-gray-200 dark:!bg-csenBlue-800 sticky bottom-0 z-40">
                     <div>
                        <v-btn class="!bg-sky-100 !text-sky-600 dark:!text-white dark:!bg-sky-600 !tracking-normal !px-4 mr-2" text
                              @click="duplicaModelloEmail(idModelloEmailAperto); closeModelloEmailDialog()">
                           <v-icon left>mdi-content-copy</v-icon>
                           <span>Duplica</span>
                        </v-btn>
                        <v-btn class="bg-red-100 dark:bg-csenRed-500 !text-csenRed-500 dark:!text-white rounded-md hover:bg-csenRed-500 hover:!text-white dark:hover:!brightness-125" text
                              @click="eliminaModelloEmail(idModelloEmailAperto); closeModelloEmailDialog()">
                           <DeleteIcon class="my-auto"></DeleteIcon>
                           <span>Elimina</span>
                        </v-btn>
                     </div>
                     <div>
                        <v-btn class="!bg-white!tracking-wider !py-5 !px-5" text @click="closeModelloEmailDialog()">Annulla</v-btn>
                        <v-btn class="!bg-csenBlue-900 dark:!bg-csenGreen-500 !text-white !tracking-wider !py-5 !px-5" text @click="$refs['modelloEmailRef'].aggiungiModifica()">Salva modifiche</v-btn>
                     </div>
                   </v-card-actions>
                </v-card>
             </v-dialog>
          </template>

          		<!-- LOGOUT -->
            <div class="block sm:flex gap-2 !justify-start border-t border-t-gray-300 dark:border-t-csenBlue-300 pt-4 mt-3">
            <template>
               <v-btn v-if="loggedAs && loggedAs.ruolo && loggedAs.ruolo.length > 0" class=" !block !mb-2 sm:!inline sm:!mb-0 !tracking-normal !bg-slate-200 !text-slate-600 dark:!text-white dark:!bg-csenBlue-800" @click="logout">
                  <v-icon left>mdi-logout</v-icon>
                  Logout
               </v-btn>
            </template>
            </div>
		  <!-- TO TOP -->
        <div 
               class="flex fixed justify-end items-end bottom-6 md:bottom-5 right-6 md:right-5 bg-csenBlue-800 rounded-full px-2 py-2 !z-[60] cursor-pointer hover:bg-csenOrange-500 transition" 
               @click="scrollToTop"
			   title="Torna in cima"
            ><div><ChevronUpIcon></ChevronUpIcon></div>
            </div>
	   	<!-- FOOTER -->
			   <div> 
				   <FooterComponent></FooterComponent>
			   </div>
		   <!-- FINE FOOTER -->          

       </div>

       <v-tour name="myTourModelliEmail" :steps="tourSteps" :options="tourOptions" :callbacks="tourCallbacks"></v-tour>

       <!-- Overlay per bloccare i click durante il tour -->
      <div v-if="tourAvviato" class="tour-overlay"></div>

    </div>
 </template>
 <script>
    import MenuTecnici from '../components/MenuTecnici.vue';
    import ModelloEmailComponent from '../components/ModelloEmailComponent.vue'

    import mixin from '../mixin';
    import store from '../store';
    
    export default {
      components: {
         MenuTecnici, ModelloEmailComponent
      },
   	mixins: [mixin],
      data() {
         return {
            isLoading: false,
            modelloEmailDialog: false,
            search: null,
            
            headers: [
               { text: 'ID', value: 'id' },
               { text: 'Nome modello', value: 'nome' },
               { text: 'Oggetto', value: 'oggetto' },
               { text: 'Data creazione', value: 'created_at' },
               { text: 'Azioni', value: 'azioni', sortable: false, class: 'text-end' },
            ],

            modelli_email: [],
            idModelloEmailAperto: null,

            modelloEmailModificato: false,

            tourAvviato: false,
				tourCallbacks: {
					onFinish: this.fineTour,
					onSkip: this.fineTour,
					onStop: this.fineTour,
				},
            tourSteps: [
               {
                  target: '#menu-modelli-email-tab',
                  content: `
                     Benvenuto nella sezione dedicata ai Modelli E-mail!<br/><br/>
                     Qui puoi creare i testi delle email da inviare ai tecnici abilitati, attraverso le circolari.
                  `
               },
               {
                  target: '#tabella-modelli-email',
                  content: `
                     In questa tabella trovi tutti i modelli email già creati, puoi cercare un modello direttamente scorrendo nella tabella oppure usando la barra di ricerca in alto dove trovi la scritta “Cerca modello e-mail”
                  `
               },
               {
                  target: '#duplica-modello-email',
                  content: `
                     Ogni modello email già esistente può essere duplicato con questo pulsante
                  `
               },
               {
                  target: '#modifica-modello-email',
                  content: `
                     Oppure puoi modificarlo cliccando sulla solita icona della matita.
                  `
               },
               {
                  target: '#elimina-modello-email',
                  content: `
                     Se invece vuoi proprio eliminare un modello allora clicca sul cestino.
                  `
               },
               {
                  target: '#aggiungi-modello-email',
                  content: `
                     Cliccando qui puoi creare un nuovo modello email.<br/><br/>
                     La guida di questa sezione è finita.<br/>
                     Per continuare la guida vai nelle altre pagine del menu.<br/><br/>
                     Saluti sportivi!
                  `
               }
            ]
         }
      },

      created() {
         this.isLoading = true;
         this.getModelliEmail(this.getModelliEmailCallback);
      },
      mounted(){
         if(!this.isGuidaCompleta('is_guida_modelli_email_completa')){
            this.tourAvviato = true;
            this.$tours['myTourModelliEmail'].start();
            this.setGuidaCompleta('is_guida_modelli_email_completa');
         }
      },

      methods:{
         avviaTour(){
            this.tourAvviato = true;
            this.$tours['myTourModelliEmail'].start();
         },
         fineTour(){
            this.tourAvviato = false;
         },
         // Il seguente spostato nel Mixin
         // getModelliEmail(){...},
         getModelliEmailCallback(data){
            this.modelli_email = data;
            this.isLoading = false;
         },
         modelloEmailAggiuntoModificato(){
            this.isLoading = true;
            this.getModelliEmail(this.getModelliEmailCallback);
            this.closeModelloEmailDialog(false);
         },

         openModelloEmailDialog(id){
            this.modelloEmailDialog = true;
            this.idModelloEmailAperto = id;
         },
         closeModelloEmailDialog(daConfermare = true){
            if(this.modelloEmailModificato && daConfermare){
					store.commit('mostraDialogConferma', 
						{
							titolo: 'Esci senza salvare le modifiche',
							testo:'Sono presenti delle modifiche, vuoi uscire senza salvarle?', 
							onConferma:()=>{
								this.modelloEmailDialog = false;
                        this.idModelloEmailAperto = null;
                        this.modelloEmailModificato = false;
								store.commit('nascondiDialogConferma');
							}, 
							onAnnulla:()=>{
								store.commit('nascondiDialogConferma');
							}
						}
					)
				} else {
					this.modelloEmailDialog = false;
               this.idModelloEmailAperto = null;
               this.modelloEmailModificato = false;
				}
         },
         duplicaModelloEmail(id){
            axios.get(`duplica_modello_email/${id}`)
               .then(res=>{
                  store.commit('mostraSnack', {messaggio: 'Modello duplicato con successo', tipo: 'success'})
                  this.isLoading = true;
                  this.getModelliEmail(this.getModelliEmailCallback);
               })
         },
         eliminaModelloEmail(id){
            store.commit('mostraDialogConferma', 
               {
                  titolo: `Elimina modello email`,
                  testo:`Sicuro di voler eliminare questo modello email?`,
                  onConferma:()=>{
                     axios.delete(`modelli_email/${id}`)
                        .then(res=>{
                           this.isLoading = true;
                           this.getModelliEmail(this.getModelliEmailCallback);
                           store.commit('mostraSnack', {messaggio: 'Modello eliminato con successo', tipo: 'success'})
                        })

                     store.commit('nascondiDialogConferma');
                  }, 
                  onAnnulla:()=>{
                     store.commit('nascondiDialogConferma');
                  }
               }
            )
         },
      }
    }

 </script>
 <style lang="scss" scoped>

 .tabella-csen {
    background-color: #fff; 
    ::v-deep .v-data-table__wrapper th {
       color: #27316e !important;
       font-size:15px !important;
       background-color: #eef5ff;
       padding: 1rem;
    }
 };

 .dark {
    ::v-deep .v-data-table__wrapper th {
       color: #c7dcfe !important;
       font-size:15px !important;
       padding: 1rem;
    }
 };

</style>
 